(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product"]) return;
  try {
    
$(document).ready(function() {
           var months    = ['January','February','March','April','May','June','July','August','September','October','November','December'];
              var now       = new Date();
              var thisMonth = months[now.getMonth()+1]; // getMonth method returns the month of the date (0-January :: 11-December)
              var output = document.getElementById('output_cw');
              console.log(thisMonth);

               if(output.textContent !== undefined) {
                  output.textContent = thisMonth;
                }
                else {
                  output.innerText = thisMonth;
                }
           }); 

  } catch(e) { console.error(e); }
})();

})();
